var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15178_2293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.385 17.7543C66.5475 10.9908 59.5133 3.95527 52.7484 2.11777C48.6004 1.08418 43.0441 0.0191406 35.5 0C27.9586 0.0191406 22.4023 1.08418 18.2543 2.11777C11.4908 3.95527 4.45527 10.9895 2.61777 17.7543C1.58418 21.901 0.519141 27.4586 0.5 35C0.517773 42.5428 1.58281 48.099 2.61641 52.2471C4.45391 59.0119 11.4895 66.0461 18.2529 67.8836C22.401 68.9172 27.96 69.9822 35.5 70C43.0414 69.9822 48.599 68.9172 52.7471 67.8836C59.5119 66.0461 66.5461 59.0119 68.3836 52.2471C69.4172 48.099 70.4822 42.54 70.5014 35C70.4836 27.4586 69.4186 21.9023 68.385 17.7543Z",
    fill: "#FFE5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2975 50.0692C59.8564 47.6657 54.3371 45.1651 49.0311 44.513C44.5375 44.0024 40.0183 43.7514 35.4959 43.761C30.9735 43.7514 26.4543 44.0025 21.9607 44.513C16.6547 45.1665 11.1354 47.6657 9.69434 50.0692C8.88359 51.543 8.05371 53.5173 8.0332 56.1983C8.04824 58.878 8.88359 60.8468 9.69434 62.326C11.1354 64.7296 16.6547 67.2302 21.9607 67.8823C26.4543 68.3928 30.9735 68.6439 35.4959 68.6343C40.0183 68.6439 44.5375 68.3928 49.0311 67.8823C54.3371 67.2302 59.8564 64.7296 61.2975 62.326C62.1082 60.8522 62.9381 58.878 62.9586 56.1983C62.9436 53.5173 62.1082 51.543 61.2975 50.0692Z",
    fill: "url(#paint0_radial_15178_2293)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4992 11.7246C30.8959 11.7249 26.3961 13.0902 22.5687 15.6478C18.7413 18.2055 15.7583 21.8406 13.9969 26.0936C12.2355 30.3466 11.7748 35.0264 12.673 39.5412C13.5712 44.056 15.788 48.2031 19.0432 51.458C22.2983 54.7129 26.4455 56.9295 30.9604 57.8275C35.4752 58.7254 40.155 58.2644 44.4079 56.5028C48.6607 54.7411 52.2957 51.7579 54.8531 47.9304C57.4106 44.1028 58.7756 39.6029 58.7756 34.9996C58.7758 31.9429 58.1738 28.9161 57.0041 26.0921C55.8344 23.2681 54.1199 20.7022 51.9584 18.5408C49.797 16.3795 47.2309 14.6651 44.4068 13.4956C41.5827 12.326 38.5559 11.7243 35.4992 11.7246ZM19.3172 34.9996C19.3192 32.1032 20.0982 29.2603 21.573 26.7674C23.0477 24.2745 25.1642 22.2229 27.7018 20.8265C30.2394 19.43 33.1052 18.7399 36.0003 18.8281C38.8954 18.9163 41.7138 19.7795 44.1617 21.3277L21.8274 43.6621C20.1811 41.0733 19.3101 38.0675 19.3172 34.9996ZM46.944 46.4443C44.3423 49.0413 40.9349 50.6763 37.2813 51.0811C33.6277 51.4858 29.945 50.6361 26.8381 48.6715L49.1711 26.3385C51.136 29.4457 51.9853 33.1289 51.5796 36.7828C51.1739 40.4367 49.5372 43.8439 46.9385 46.4443H46.944Z",
    fill: "url(#paint1_linear_15178_2293)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_15178_2293",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.5014 55.7558) scale(27.4572 12.3558)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3739",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF3739",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15178_2293",
    x1: 51.9574,
    y1: 51.4578,
    x2: 19.0424,
    y2: 18.5428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EF3739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C8B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15178_2293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBan);
export default __webpack_public_path__ + "static/media/ban.a2db6e47b47dcb7d963761d679f89770.svg";
export { ForwardRef as ReactComponent };